import { createApp } from 'vue'
import vuetify from './plugins/vuetify.js'
import router from './router.js'
import head from './plugins/unhead.js'
import App from './App.vue'
import pinia from './plugins/pinia.js'
import '@mdi/font/css/materialdesignicons.css'
import i18n from './plugins/i18n.js'
import './styles/main.scss'

createApp(App).use(router).use(vuetify).use(pinia).use(i18n).use(head).mount('#app')
